import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import InputForm from "./InputForm";
import "./Form.css";

const { Item: ItemForm } = Form;

export default class GrupoPessoaForm extends Component {
  state = {
    registro: {
      grpes_codigo: '',
      grpes_descricao: '',
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado.data,
        visualizar: this.props.registroSelecionado.visualizar,
      }, () => {
        this.refs.grpes_codigo.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if ((!this.state.registro.grpes_descricao) || (this.state.registro.grpes_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    this.props.onSalvarClick(this.state.registro);
  };

  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { grpes_idf, grpes_codigo, grpes_descricao } = this.state.registro;

    return (
      <Modal
        title={grpes_idf ? "Edição de Grupo" : "Cadastro de Grupo"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={4} className="camposEspacoDireita">
              <span>Código</span>
              <InputForm
                id="grpes_codigo"
                ref="grpes_codigo"
                maxLength={30}
                onChange={this.onChange}
                value={grpes_codigo}
                validator={value => Boolean(value)}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={20}>
              <span>Descrição *</span>
              <InputForm
                id="grpes_descricao"
                ref="grpes_descricao"
                maxLength={30}
                onChange={this.onChange}
                value={grpes_descricao}
                validator={value => Boolean(value)}
              />
            </Col>
          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar
                  </Button>
                )}

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GrupoPessoaForm.js